const schools = (state) => state;

const geo = (state) => state.geo;

export default {
    schools,
    geo,
};
